import { Element, useNode } from "@craftjs/core";
import React, { FC } from "react";

import { CButton } from "./CButton";
import { CContainer, CContainerDefaultProps, CContainerSettings } from './CContainer';
import { CText } from "./CText";

interface CCardTopProps {
  children: React.ReactNode;
  [key: string]: any;
}

export const CCardTop = ({ children, ...props }: CCardTopProps) => {
  const {
    connectors: { connect }
  } = useNode();
  
  return (
    <div
      {...props}
      ref={(val: any) => connect(val)}
      className="text-only"
      style={{
        padding: "10px",
        marginBottom: "10px",
        borderBottom: "1px solid #eee",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start"
      }}
    >
      {children}
    </div>
  );
};

CCardTop.craft = {
  rules: {
    canMoveIn: (incomingNode: any) => incomingNode.data.type === Text
  }
};

// Define props interface for CCardBottom
interface CCardBottomProps {
  children: React.ReactNode;
  [key: string]: any; // Allow additional props
}

export const CCardBottom = ({ children, ...props }: CCardBottomProps) => {
  const {
    connectors: { connect }
  } = useNode();

  return (
    <div {...props} style={{ padding: "10px 0" }} ref={(val: any) => connect(val)}>
      {children}
    </div>
  );
};

CCardBottom.craft = {
  rules: {
    canMoveIn: (incomingNode: any) => incomingNode.data.type === CButton
  }
};

// Define props interface for CCard
interface CCardProps {
  background?: string;
  padding?: number;
  [key: string]: any; // Allow additional props
}

export const CCard = ({ background, padding = 20, ...props }: CCardProps) => {
  return (
    <CContainer {...props} background={background} padding={padding}>
      <Element canvas id="text" is={CCardTop} data-cy="card-top">
        <CText text="Only texts" fontSize={20} data-cy="card-top-text-1" />
        <CText
          text="are allowed up here"
          fontSize={15}
          data-cy="card-top-text-2"
        />
      </Element>
      <Element canvas id="buttons" is={CCardBottom} data-cy="card-bottom">
        <CButton
          size="small"
          text="Only buttons down here"
          data-cy="card-bottom-button"
        />
      </Element>
    </CContainer>
  );
};

CCard.craft = {
  displayName: "Card",
  props: CContainerDefaultProps,
  related: {
    settings: CContainerSettings
  }
};
